import { Action, Selector, State, StateContext } from '@ngxs/store';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants/error';
import { NotificationService } from '../../../../../common';
import { Observable, of } from 'rxjs';
import { ShipmentTransportOrderLoadsService } from './shipment-transport-order-loads.service';
import {
  ShipmentTransportOrderLoadsInitialState,
  ShipmentTransportOrderLoadsLoad,
} from './shipment-transport-order-loads.actions';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ShipmentTransportOrderLoadModel } from '../../models/shipment-transport-order-load.model';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentTransportOrderLoadsStateModel {
  loads: ShipmentTransportOrderLoadModel[];
  loaded: boolean;
}

const initialState: ShipmentTransportOrderLoadsStateModel = {
  loads: [],
  loaded: false,
};

@State<ShipmentTransportOrderLoadsStateModel>({
  name: 'shipmentTransportOrderLoads',
  defaults: initialState,
})
@Injectable()
export class ShipmentTransportOrderLoadsState {
  @Selector()
  static getState(state: ShipmentTransportOrderLoadsStateModel): ShipmentTransportOrderLoadsStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentTransportOrderLoadsStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getLoads(state: ShipmentTransportOrderLoadsStateModel): ShipmentTransportOrderLoadModel[] {
    return state.loads;
  }

  constructor(
    private shipmentTransportOrderLoadsService: ShipmentTransportOrderLoadsService,
    private notificationService: NotificationService,
  ) {}

  @Action(ShipmentTransportOrderLoadsLoad)
  getShipmentTransportOrderLoads(
    ctx: StateContext<ShipmentTransportOrderLoadsStateModel>,
    { payload }: ShipmentTransportOrderLoadsLoad,
  ): Observable<void | MatSnackBarRef<SimpleSnackBar>> {
    return this.shipmentTransportOrderLoadsService.getShipmentTransportOrderLoads(payload).pipe(
      map((loads: ShipmentTransportOrderLoadModel[]) => {
        ctx.patchState({
          loads: loads.map((load: ShipmentTransportOrderLoadModel) => new ShipmentTransportOrderLoadModel(load)),
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentTransportOrderLoadsInitialState)
  setInitialState(ctx: StateContext<ShipmentTransportOrderLoadsStateModel>): void {
    ctx.setState(initialState);
  }
}
